import { Row, Col, Panel, Content, Navbar, DateRangePicker, IconButton, Pagination, Table } from "rsuite"
import SettingIcon from '@rsuite/icons/Setting';
import { Children, useEffect, useState } from "react";

import { useParams } from "react-router-dom";

import ActionCell from "../tables/actionCell";
import StatusCell from "../tables/statusCell";
import PlatformCell from "../tables/platformCell";
import TagCell from "../tables/tagCell";
import ValidatedValueCell from "../tables/validatedValueCell";
import StyledCell from "../tables/styledCell";

import AnalyticsHeader from "./analyticsHeader";

const getAnalytics = (key, setData, setLoading) => {
    fetch(`${process.env.REACT_APP_API_HOST}/api/status/${key}`, {
            method: 'GET'
      }).then((res) => {
        res.json().then((data) => {
            let r = [];

            setData(data.result.map((item) => {
                let max_rows = Math.max(item.source_chemicals.length,
                                        item.source_sources.length,
                                        item.source_tools.length);
                return {
                    ...item,
                    max_rows,
                    validated: item.source_cost < 140000
                }
            }));
            console.log(data)
            setLoading(false);
        });
      });
    };

export default function AnalyticList() {
    const { key } = useParams();
    const [data, setData] = useState([]);
    const [filteredData, _setFilteredData] = useState([]);

    const setFilteredData = (data) => {
        console.log(page, limit, data)
        let _ = data.filter((v, i) => {
            const start = limit * (page - 1);
            const end = start + limit;
            return i >= start && i < end;
          });

        
        setTableLength(data.length);
        _setFilteredData(_);
    }

    const { Column, HeaderCell, Cell } = Table;

    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(1);
    const [tableLength, setTableLength] = useState();

    const [sortColumn, setSortColumn] = useState("platform_number");
    const [sortType, setSortType] = useState("asc");

    const [loading, setLoading] = useState(true);

    const handleSortColumn = (sortColumn, sortType) => {
        setSortColumn(sortColumn);
        setSortType(sortType);
        setFilteredData(
            data.sort((a, b) => {
                console.log(a[sortColumn], b[sortColumn])
                if (sortType === "asc") {
                    return parseInt(a[sortColumn]) > parseInt(b[sortColumn]) ? 1 : -1;
                }
                return parseInt(a[sortColumn]) < parseInt(b[sortColumn]) ? 1 : -1;
            })
        )
      };

    const handleChangeLimit = dataKey => {
        setPage(1);
        setLimit(dataKey);
    };

    useEffect(() => {
        setFilteredData(data);
    }, [data]);

    useEffect(() => {
        getAnalytics(key, setData, setLoading)
    }, []);

    useEffect(() => {
        setFilteredData(data);
    }, [page]);

    useEffect(() => {
    }, [sortColumn, sortType]);

    return (
        <div style={{ height: "100%"}}>
            <AnalyticsHeader data={data} />
            <div style={{ height: "calc(100% - 10rem)" }}>
                <Table sortColumn={sortColumn} sortType={sortType} onSortColumn={handleSortColumn} fillHeight
                    rowHeight={rowData => rowData?.max_rows * 38} className="table-hover" hover loading={loading} data={filteredData}>
                    <Column verticalAlign="middle" align="center" sortable flexGrow={1}>
                        <HeaderCell>Платформа</HeaderCell>
                        <PlatformCell dataKey="platform_number"></PlatformCell>
                    </Column>
                    <Column align="center" flexGrow={2}>
                        <HeaderCell>Котлы</HeaderCell>
                        <TagCell dataKey="source_tools"></TagCell>
                    </Column>
                    <Column verticalAlign="middle" align="center" flexGrow={1}>
                        <HeaderCell>Тип топлива</HeaderCell>
                        <Cell dataKey="source_fuel"></Cell>
                    </Column>
                    <Column verticalAlign="middle" align="center" flexGrow={1}>
                        <HeaderCell>Расход</HeaderCell>
                        <ValidatedValueCell dataKey="source_cost"></ValidatedValueCell>
                    </Column>
                    <Column align="center" flexGrow={2}>
                        <HeaderCell>Источники</HeaderCell>
                        <TagCell dataKey="source_sources"></TagCell>
                    </Column>
                    <Column align="center" flexGrow={2}>
                        <HeaderCell>Химикаты</HeaderCell>
                        <TagCell dataKey="source_chemicals"></TagCell>
                    </Column>
                </Table>
            </div>
            <div style={{ padding: 20 }}>
                <Pagination
                    prev
                    next
                    first
                    last
                    ellipsis
                    boundaryLinks
                    maxButtons={5}
                    size="xs"
                    layout={['total', '-', 'limit', '|', 'pager', 'skip']}
                    total={tableLength}
                    limitOptions={[10, 30, 50]}
                    limit={limit}
                    activePage={page}
                    onChangePage={setPage}
                    onChangeLimit={handleChangeLimit}
                />
            </div>
        </div>
    )
}